import SearchResultItem from './SearchResultItem';

const SearchResult = ({
    showResult,
    locations,
    onSearchResultItemEnter,
    onSearchResultItemLeave,
    onSearchResultItemClicked,
    selectedLocation,
    customerType
}) => {

    const handleMouseEnter = (location, index) => {
        if (onSearchResultItemEnter) {
            onSearchResultItemEnter(location, index);
        }
    };

    const handleMouseLeave = (location, index) => {
        if (onSearchResultItemLeave) {
            onSearchResultItemLeave(location, index);
        }
    };

    const handleClick = (location, index) => {
        if (onSearchResultItemClicked) {
            onSearchResultItemClicked(location, index);
        }
    };

    return (
        <div className='search-result-container'>
            {customerType ? (
                showResult ? (
                    <>
                        <div className='search-result-heading'>
                            <span>Partner in Ihrer Nähe</span>
                            <strong>{locations.length} {locations.length === 1 ? 'Ergebnis' : 'Ergebnisse'}</strong>
                        </div>
                        <div className='search-result-items-container'>
                            {locations.map((location, index) => (
                                <SearchResultItem
                                    key={index}
                                    location={location}
                                    onMouseEnter={handleMouseEnter}
                                    onMouseLeave={handleMouseLeave}
                                    onClick={handleClick}
                                    index={index}
                                    isSelected={selectedLocation && selectedLocation.id === location.id}
                                />
                            ))}
                        </div>
                    </>
                ) : (
                    <div className='search-result-notice px-4 py-3'>Bitte geben Sie einen Ort ein, um E3/DC-Fachpartner in Ihrer Nähe zu finden.</div>
                ))
                : (
                    <div className='search-result-notice search-result-notice-centered px-4 py-3'>Bitte wählen Sie eine Option.</div>
                )}
        </div>
    );
};

export default SearchResult;
